api = require('../api.coffee').api()

class global.LostReasonsResource extends ResourceBase
  @MODEL = LostReason
  @SINGULAR_RESOURCE_NAME = 'lost_reason'
  @PLURAL_RESOURCE_NAME = 'lost_reasons'

  index: (success, failure, params = {}) ->
    api.get("/lost_reasons", params, { success: @collectionSuccess(success), failure })

  create: (success, failure, params = {}) ->
    api.post("/lost_reasons", params, {success, failure})

  update: (success, failure, params={}) ->
    api.put("/lost_reasons/#{@getParamsId(params)}", params, {success: @memberSuccess(success), failure})

  destroy: (success, failure, params={}) ->
    api.delete("/lost_reasons/#{@getParamsId(params)}", {}, {success, failure})



// WEBPACK FOOTER //
// ./src/resources/lost_reasons.coffee